// Day-month ranges without year, MMDD strings ('0601'): hotel closed periods and business date (CU-869fmq3zd).
// start > end means the range crosses the year end (e.g. 1201 -> 0115). Both ends inclusive.
import { monthNames } from 'app/@utils/dateLocale'

// Days per month of a leap year: Feb 29 is a valid closed day.
export const DAYS_IN_MONTH = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31]

export const toMmdd = (month, day) => `${String(month).padStart(2, '0')}${String(day).padStart(2, '0')}`

export const isInRange = (mmdd, start, end) => start <= end ?
    mmdd >= start && mmdd <= end :
    mmdd >= start || mmdd <= end

export const isClosedDay = (mmdd, periods = []) => periods.some(({ start, end }) => isInRange(mmdd, start, end))

// '0601' -> '1 Jun' (month name in the active language)
export const formatMmdd = (mmdd, months = monthNames('short')) => `${parseInt(mmdd.slice(2), 10)} ${months[parseInt(mmdd.slice(0, 2), 10) - 1]}`

export const formatPeriod = ({ start, end }, months = monthNames('short')) => start === end ?
    formatMmdd(start, months) :
    `${formatMmdd(start, months)} – ${formatMmdd(end, months)}`

// Business date column format (CU-869fmq3zd phase 2): 'MMDD-MMDD,MMDD-MMDD' <-> [{start, end}]
export const parseRangesCsv = csv => !csv ? [] : String(csv).split(',').map(part => part.trim()).filter(Boolean)
    .map(part => {
        const [start, end] = part.split('-')
        return { start, end }
    })

export const formatRangesCsv = ranges => ranges?.length ? ranges.map(({ start, end }) => `${start}-${end}`).join(',') : null

// '0401-0630,1201-0115' -> '1 Apr – 30 Jun, 1 Dec – 15 Jan' (month names in the active language)
export const formatRangesLabel = csv => {
    const months = monthNames('short')
    return parseRangesCsv(csv).map(range => formatPeriod(range, months)).join(', ')
}
